export default {
  ADD_COMPARE: '/auth/compare/add',
  DELETE_COMPARE: '/auth/compare/delect',
  brandList: '/auth/compare/brandDetail',
  brandMarket: '/auth/compare/brandDetailMarket',
  formulationList: '/auth/formulation/getFormulationCompare',
  INCIList: '/auth/trade/inci/ingredientCompare',
  productINCI: '/auth/product/productCompositionCompare',
  productDetail: '/auth/product/productDetailCompare',
  // product > function
  productFunction: '/auth/public/get_basfFunction'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/compare.js